import {
  GetCargoTypesResponse,
  MotorCarrierApplicationService,
} from '@/@types/generated'
import { useCallback, useEffect, useState } from 'react'

interface UseCarrierCargoTypesResult {
  cargoTypes: GetCargoTypesResponse | null
  loading: boolean
  error: unknown
  /** Re-fetches the cargo types, e.g. after a Hazmat override changes them. */
  refresh: () => void
}

/**
 * A carrier's cargo types. With an applicationId, Hazardous follows that application's Hazmat
 * override instead of the carrier's.
 */
export function useCarrierCargoTypes(
  usdotNumber?: number,
  applicationId?: string
): UseCarrierCargoTypesResult {
  const [cargoTypes, setCargoTypes] = useState<GetCargoTypesResponse | null>(
    null
  )
  const [loading, setLoading] = useState(false)
  const [error, setError] = useState<unknown>(null)
  const [reloadKey, setReloadKey] = useState(0)

  const refresh = useCallback(() => setReloadKey((key) => key + 1), [])

  useEffect(() => {
    if (!usdotNumber) {
      setCargoTypes(null)
      setError(null)
      return
    }

    setLoading(true)
    setError(null)

    MotorCarrierApplicationService.getCargoTypes(usdotNumber, applicationId)
      .then(setCargoTypes)
      .catch((e: unknown) => {
        setCargoTypes(null)
        setError(e)
      })
      .finally(() => setLoading(false))
  }, [usdotNumber, applicationId, reloadKey])

  return { cargoTypes, loading, error, refresh }
}
